import React from 'react';
import link from 'link.svg';
import ErrorBoundary from './ErrorBoundary';

function CopyLink({ copyLink = window.location.href }) {
  const copy = () => {
    const hiddenInput = document.createElement('input');
    hiddenInput.value = copyLink;
    document.body.appendChild(hiddenInput);
    hiddenInput.select();
    document.execCommand('copy');
    document.body.removeChild(hiddenInput);
    // toast.success('Copied link to clipboard');
    const event = new CustomEvent('toast-message', {
      detail: 'Copied link to clipboard',
    });
    document.dispatchEvent(event);
  };

  return (
    // eslint-disable-next-line
    <li onClick={copy}>
      <img data-src={link} alt="" title="Copy Link Icon" className="lazyload" />
      <span>Copy Link</span>
    </li>
  );
}

export default function CopyLinkWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <CopyLink {...props} />
    </ErrorBoundary>
  );
}
